import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enable attachment for the help center phone callback form
 */
export const HELP_CENTER_PHONE_CALLBACK_ATTACHMENT_240507 =
  'HELP_CENTER_PHONE_CALLBACK_ATTACHMENT_240507' as SettingConst<
    'HELP_CENTER_PHONE_CALLBACK_ATTACHMENT_240507',
    boolean,
    'HELP_CENTER'
  >;
